module.exports = __webpack_public_path__ + "static/media/disabledIconExpert.e264753e.svg";